// extracted by mini-css-extract-plugin
export default {"message":"CallTranscript_message__hN2Rv","messageText":"CallTranscript_messageText__wfG+b"};